import { ChevronDownIcon, CloseIcon, PhoneIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { putApi } from "common/services/api";
import { setUser } from "../../redux/reducers/localSlice";
import WhiteEditIcon from "common/assets/img/whiteEditIcon.png";
import { constant } from "common/constant";
import { updateUserSchema } from "common/schema/userSchema";

const EditUser = (props) => {
  const {
    setAction,
    fetchData,
    data,
    userData,
    viewMode = false,
    permission,
    setViewMode,
    setShowEmail,
    setShowCalendar,
    selectedId,
    provideFormikConfig = () => { }
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const handleSelectEmail = () => {
    setShowDropdown(false);
    setShowEmail(true);
    setShowCalendar(false);
  };

  const handleSelectCalendar = () => {
    setShowDropdown(false);
    setShowCalendar(true);
    setShowEmail(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const initialValues = {
    firstName: data ? data?.firstName : "",
    lastName: data ? data?.lastName : "",
    username: data ? data?.username : "",
    phoneNumber: data ? data?.phoneNumber : "",
  };

  const user = JSON.parse(window.localStorage.getItem("user"));

  const { formik } = props;


  useEffect(() => {
    if (!provideFormikConfig) return;

    const config = {
      initialValues,
      validationSchema: updateUserSchema,
      onSubmit: async (values, { resetForm }) => {
        await EditData(values);
        resetForm();
      },
    };

    provideFormikConfig(config);

  }, [data]);
  const handleCloseModal = () => {
    // setEdit(false);
    formik?.resetForm();
  };

  const EditData = async (values) => {
    try {
      setIsLoading(true);
      const updatedFields = {};
      if (values.firstName !== initialValues.firstName)
        updatedFields.firstName = values.firstName;
      if (values.lastName !== initialValues.lastName)
        updatedFields.lastName = values.lastName;
      if (values.phoneNumber !== initialValues.phoneNumber)
        updatedFields.phoneNumber = values.phoneNumber;

      let response = await putApi(`api/user/edit/${selectedId}`, updatedFields);

      if (response && response.status === 200) {
        // setEdit(false);

        let updatedUserData = userData;
        if (user?._id === selectedId) {
          updatedUserData = {
            ...updatedUserData,
            ...updatedFields,
          };
          localStorage.setItem("user", JSON.stringify(updatedUserData));
          dispatch(setUser(JSON.stringify(updatedUserData)));
        }

        handleCloseModal();
        fetchData();
        setAction((pre) => !pre);
      } else {
        toast.error(response.response.data?.message);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={formik?.handleSubmit}>
      <Box className="manualFormContainer test">
        <Box className="manualFormBody">
          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel display="flex" fontSize="sm" fontWeight="500" mb="8px">
                First Name<Text color="red">*</Text>
              </FormLabel>
              <Input
                disabled={viewMode}
                fontSize="sm"
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                value={formik?.values.firstName}
                name="firstName"
                placeholder="First Name"
                fontWeight="500"
                borderColor={
                  formik?.errors.firstName && formik?.touched.firstName ? "red.300" : undefined
                }
              />
              <Text mb="10px" color="red">
                {formik?.errors.firstName && formik?.touched.firstName && formik?.errors.firstName}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 6 }}>
              <FormLabel display="flex" fontSize="sm" fontWeight="500" mb="8px">
                Last Name
              </FormLabel>
              <Input
                disabled={viewMode}
                fontSize="sm"
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                value={formik?.values.lastName}
                name="lastName"
                placeholder="Last Name"
                fontWeight="500"
                borderColor={
                  formik?.errors.lastName && formik?.touched.lastName ? "red.300" : undefined
                }
              />
              <Text mb="10px" color="red">
                {formik?.errors.lastName && formik?.touched.lastName && formik?.errors.lastName}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 6 }}>
              <FormLabel display="flex" fontSize="sm" fontWeight="500" mb="8px">
                Email<Text color="red">*</Text>
              </FormLabel>
              <Input
                disabled
                fontSize="sm"
                type="email"
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                value={formik?.values.username}
                name="username"
                placeholder="Email Address"
                fontWeight="500"
              />
              <Text mb="10px" color="red">
                {formik?.errors.username && formik?.touched.username && formik?.errors.username}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 6 }}>
              <FormLabel display="flex" fontSize="sm" fontWeight="500" mb="8px">
                Phone Number
              </FormLabel>
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={<PhoneIcon color="gray.300" />}
                />
                <Input
                  disabled={viewMode}
                  type="tel"
                  fontSize="sm"
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  value={formik?.values.phoneNumber}
                  name="phoneNumber"
                  fontWeight="500"
                  placeholder="Phone number"
                  borderRadius="8px"
                  borderColor={
                    formik?.errors.phoneNumber && formik?.touched.phoneNumber
                      ? "red.300"
                      : undefined
                  }
                />
              </InputGroup>
              <Text mb="10px" color="red">
                {formik?.errors.phoneNumber &&
                  formik?.touched.phoneNumber &&
                  formik?.errors.phoneNumber}
              </Text>
            </GridItem>
          </Grid>
        </Box>

        {/* <Flex className="manualFormFooter">
          {viewMode ? (
            (user.role === "superAdmin" || permission?.update) && (
              <Button
                disabled={isLoading}
                onClick={() => setViewMode(false)}
                className="viewEditBtn"
                type="button"
              >
                <Image src={WhiteEditIcon} alt="edit" h="16px" w="16px" />
                {constant.edit}
              </Button>
            )
          ) : (
            <Flex gap="16px">
              <Button
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  setViewMode(true);
                  formik.setValues(initialValues);
                }}
                variant="outline"
                className="cancelBtn theme-btn2"
                size="sm"
                type="button"
              >
                {constant.cancel}
              </Button>

              <Button
                sx={{ textTransform: "capitalize" }}
                type="submit"
                disabled={
                  isLoading ||
                  (values.firstName === initialValues.firstName &&
                    values.lastName === initialValues.lastName &&
                    values.phoneNumber === initialValues.phoneNumber) ||
                  !!errors.firstName ||
                  !!errors.lastName ||
                  !!errors.phoneNumber
                }
                className="viewEditBtn"
              >
                {isLoading ? <Spinner /> : constant.upload}
              </Button>
            </Flex>
          )}
        </Flex> */}
      </Box>
    </form>
  );
};

export default EditUser;
